// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlePreview__popup-a9c780 {
  width: 100%;
  max-width: calc(100vw - var(--sidebar-width));
  left: auto;
  z-index: 0;
  display: flex;
  flex-direction: column;
}

.ArticlePreview__container-fb1515 {
  overflow-y: auto;
  flex: 1;
}

.ArticlePreview__content-ca2dfd {
  margin: 0 auto;
  max-width: var(--max-width-article-layout);
  padding: 0 24px;
}

.ArticlePreview__reactions-cdf0a9 {
  margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/ArticlePreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,6CAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,OAAA;AACF;;AAEA;EACE,cAAA;EACA,0CAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".popup {\n  width: 100%;\n  max-width: calc(100vw - var(--sidebar-width));\n  left: auto;\n  z-index: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.container {\n  overflow-y: auto;\n  flex: 1;\n}\n\n.content {\n  margin: 0 auto;\n  max-width: var(--max-width-article-layout);\n  padding: 0 24px;\n}\n\n.reactions {\n  margin-bottom: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `ArticlePreview__popup-a9c780`,
	"container": `ArticlePreview__container-fb1515`,
	"content": `ArticlePreview__content-ca2dfd`,
	"reactions": `ArticlePreview__reactions-cdf0a9`
};
module.exports = ___CSS_LOADER_EXPORT___;
